import { UnreachableError } from '@/utils/errors';

import type { EntityType } from '../types/EntityType';

/**
 * Returns the extended display kind label for an entity type.
 * This matches the same extended display kind that would be returned
 * by the server for actual entity instances.
 */
export const getExtendedDisplayKindFromEntityType = (
  entityType: EntityType
): string => {
  switch (entityType) {
    // Trust entities
    case 'irrevocable-trust':
      return 'Irrevocable trust';
    case 'revocable-trust':
      return 'Revocable trust';
    case 'slat':
      return 'Spousal lifetime access trust (SLAT)';
    case 'grat':
      return 'Grantor-retained annuity trust (GRAT)';
    case 'ilit':
      return 'Irrevocable life insurance trust (ILIT)';
    case 'qprt':
      return 'Qualified personal residence trust (QPRT)';

    // Personal account entities
    case 'individual-account':
      return 'Personal assets and liabilities';
    case 'joint-account':
      return 'Joint assets and liabilities';
    case 'retirement-account':
      return 'Retirement accounts';
    case 'insurance-account':
      return 'Directly held life insurance';
    case 'custodial-account':
      return 'UGMA/UTMA accounts';
    case 'qualified-tuition-account':
      return '529 plans';

    // Charitable entities
    case 'crt':
      return 'Charitable remainder trust (CRT)';
    case 'clt':
      return 'Charitable lead trust (CLT)';
    case 'daf':
      return 'Donor advised fund (DAF)';
    case 'private-foundation':
      return 'Private foundation';

    // Business entities
    case 'llc':
      return 'Limited liability company (LLC)';
    case 'gp':
      return 'General partnership (GP)';
    case 'lp':
      return 'Limited partnership (LP)';
    case 's-corp':
      return 'S-corporation';
    case 'c-corp':
      return 'C-corporation';
    case 'sole-proprietorship':
      return 'Sole proprietorship';

    default:
      throw new UnreachableError({
        case: entityType,
        message: 'Unexpected entity type',
      });
  }
};
